import * as types from '../_constants'
let listID = 3
let cardID = 1
const initialState = {
  loading: true,
  recommendationLoading: true,
  error: null,
  recommendation: '',
  allRecommendation: '',
  singleRecommendation: '',
}
// eslint-disable-next-line
const recommendationListReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.FETCH_RECOMMENDATION_REQUEST:
        return {
          ...state,
          recommendationLoading: true,
        }
      case types.FETCH_RECOMMENDATION_SUCCESS:
        return {
          ...state,
          loading: false,
          recommendation: action.payload,
          error: '',
        }
        break
      case types.FETCH_RECOMMENDATION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        }
        break
      case types.FETCH_ALL_RECOMMENDATION_SUCCESS:
        return {
          ...state,
          loading: false,
          recommendationLoading: false,
          allRecommendation: action.payload,
          error: '',
        }
        break
      case types.FETCH_ALL_RECOMMENDATION_FAILURE:
        return {
          ...state,
          loading: false,
          recommendationLoading: false,
          error: action.payload,
        }
        break
      case types.FETCH_UPDATERECOMMENDATION_SUCCESS:
        return {
          ...state,
          loading: false,
          recommendation: action.payload,
          error: '',
        }
        break
      case types.FETCH_UPDATERECOMMENDATION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        }
        break
      case types.CREATE_NEW_RECOMMENDATION_SUCCESS:
        return {
          ...state,
          error: '',
        }
        break
      case types.CREATE_NEW_RECOMMENDATION_FAILURE:
        return {
          ...state,
          error: action.payload,
        }
        break
      case types.GET_RECOMMENDATION_SUCCESS:
        return {
          ...state,
          singleRecommendation:action.payload,
          error: '',
        }
      case types.GET_RECOMMENDATION_FAILURE:
        return {
          ...state,
          singleRecommendation:'',
          error: action.payload,
        }
      case types.UPDATE_RECOMMENDATION_FAILURE:
        return {
          ...state,
          error: action.payload,
        }
      case types.CLEAR_RECOMMENDATION_STATE:
        return {
          ...state,
          singleRecommendation: '',
        }
      case types.DELETE_RECOMMENDATION_SUCCESS:
        return{
          ...state,
          error : ''
        }
      case types.DELETE_RECOMMENDATION_SUCCESS:
        return{
          ...state,
          error : action.payload
        }
      default:
        return state
    }
}
export default recommendationListReducer
